import { ADDRESS_TRIGGER_CHAR } from '../../search/address-trigger';

export const JOURNAL_TRANSLATIONS = {
  journal: {
    de: 'Journal',
    en: 'Journal',
    fr: 'Journal',
  },

  //create / edit dialog
  journalEntry_awaiting_message: {
    de: 'Meldung',
    en: 'Awaiting message',
    fr: 'En attente de message',
  },
  journalEntry_awaiting_triage: {
    de: 'Triage',
    en: 'Awaiting triage',
    fr: 'En attente de triage',
  },
  journalEntry_awaiting_decision: {
    de: 'Entscheidung',
    en: 'Awaiting decision',
    fr: 'En attente de décision',
  },
  journalEntry_awaiting_completion: {
    de: 'Abschluss',
    en: 'Awaiting completion',
    fr: 'En attente de finalisation',
  },
  journalEntry_completed: {
    de: 'Abgeschlossen',
    en: 'Completed',
    fr: 'Terminé',
  },
  journalEntryResponsibility_awaiting_triage: {
    de: 'Triage',
    en: 'Triage',
    fr: 'Triage',
  },
  journalEntryResponsibility_awaiting_completion: {
    de: 'Ausgang',
    en: 'Output',
    fr: 'Sortie',
  },
  journalEntryResponsibility_completed: {
    de: '-',
    en: '-',
    fr: '-',
  },

  messageNumber: {
    de: 'Meldungsnummer',
    en: 'Report number',
    fr: 'Numéro de rapport',
  },
  messageNumberAutoGenerated: {
    de: 'Meldungsnummer wird beim Speichern automatisch generiert.',
    en: 'Report number will be automatically generated when saving.',
    fr: "Le numéro de rapport sera généré automatiquement lors de l'enregistrement.",
  },
  messageNumberManualEntry: {
    de: 'Meldungsnummer manuell erfassen',
    en: 'Enter report number manually',
    fr: 'Saisir le numéro de rapport manuellement',
  },
  messageNumberAlreadyExists: {
    de: 'Die Meldungsnummer {number} existiert bereits.',
    en: 'Report number {number} already exists.',
    fr: 'Le numéro de rapport {number} existe déjà.',
  },
  deliverer: {
    de: 'Absender',
    en: 'Deliverer',
    fr: 'Livreur',
  },
  receiver: {
    de: 'Empfänger',
    en: 'Receiver',
    fr: 'Destinataire',
  },
  date: {
    de: 'Datum',
    en: 'Date',
    fr: 'Date',
  },
  time: {
    de: 'Zeit',
    en: 'Time',
    fr: 'Heure',
  },
  communicationDevice: {
    de: 'Kommunikationsmittel',
    en: 'Communication device',
    fr: 'Dispositif de communication',
  },
  phone: {
    de: 'Telefon',
    en: 'Phone',
    fr: 'Téléphone',
  },
  radio: {
    de: 'Funk',
    en: 'Radio',
    fr: 'Radio',
  },
  mail: {
    de: 'E-Mail',
    en: 'eMail',
    fr: 'eMail',
  },
  fax: {
    de: 'Fax',
    en: 'Fax',
    fr: 'Fax',
  },
  email: {
    de: 'E-Mail',
    en: 'Email',
    fr: 'Email',
  },
  sms: {
    de: 'SMS',
    en: 'SMS',
    fr: 'SMS',
  },
  courier: {
    de: 'Übermittler',
    en: 'Messager',
    fr: 'Messager',
  },
  other: {
    de: 'Andere',
    en: 'Other',
    fr: 'Autre',
  },
  messageSubject: {
    de: 'Betreff',
    en: 'Subject',
    fr: 'Sujet',
  },
  messageContent: {
    de: 'Meldungsinhalt',
    en: 'Message content',
    fr: 'Contenu du message',
  },
  detailsChanel: {
    de: 'Nummer / Kanal',
    en: 'Number / channel',
    fr: 'Numéro / canal',
  },
  visa: {
    de: 'Visum',
    en: 'Visa',
    fr: 'Visa',
  },
  author: {
    de: 'Verfasser',
    en: 'Author',
    fr: 'Auteur',
  },
  keyMessage: {
    de: 'Schlüsselmeldung',
    en: 'Key message',
    fr: 'Message clé',
  },
  keyMessageShort: {
    de: 'Schlüssel',
    en: 'Key',
    fr: 'clé',
  },
  department: {
    de: 'Fachbereich',
    en: 'Department',
    fr: 'Département',
  },
  dateTriage: {
    de: 'Triage Zeitpunkt',
    en: 'Triage time',
    fr: 'Heure de triage',
  },
  visumTriage: {
    de: 'Visum Triage',
    en: 'Visa triage',
    fr: 'Visa de triage',
  },
  messageReceiver: {
    de: 'Empfänger der Entscheidung',
    en: 'Receiver of decision',
    fr: 'Destinataire de la décision',
  },
  dateDecision: {
    de: 'Entscheidungszeitpunkt',
    en: 'Decision time',
    fr: 'Heure de décision',
  },
  visumDecider: {
    de: 'Visum Entscheidung',
    en: 'Visa decision',
    fr: 'Visa de décision',
  },
  //department values
  noDepartment: {
    de: 'Kein Fachbereich',
    en: 'No department',
    fr: 'Pas de département',
  },
  'politische-behoerde': {
    de: 'Politische Behörde',
    en: 'Political authority',
    fr: 'Autorité politique',
  },
  'chef-fuehrungsorgan': {
    de: 'Chef Führungsorgan',
    en: 'Chief executive body',
    fr: 'Organe directeur',
  },
  stabschef: {
    de: 'Stabschef',
    en: 'Chief staff',
    fr: 'Chef du personnel',
  },
  'fb-lage': {
    de: 'FB Lage',
    en: 'DP Location',
    fr: 'DP localisation',
  },
  'fb-information': {
    de: 'FB Information',
    en: 'DP Information',
    fr: 'DP Information',
  },
  'fb-oeffentliche-sicherheit': {
    de: 'FB Sicherheit',
    en: 'DP Safety',
    fr: 'DP Sécurité',
  },
  'fb-schutz-rettung': {
    de: 'FB Schutz und Rettung',
    en: 'DP Safety and Rescue',
    fr: 'DP Sécurité et sauvetage',
  },
  'fb-gesundheit': {
    de: 'FB Gesundheit',
    en: 'DP Health',
    fr: 'DP Santé',
  },
  'fb-logistik': {
    de: 'FB Logistik',
    en: 'DP Logistics',
    fr: 'DP Logistique',
  },
  'fb-infrastrukturen': {
    de: 'FB Infrastruktur',
    en: 'DP Infrastructure',
    fr: 'DP Infrastructure',
  },
  wrongContent: {
    de: 'Falscher Inhalt',
    en: 'Wrong content',
    fr: 'Mauvais contenu',
  },
  wrongContentMessage: {
    de: 'Falls dieser Journaleintrag nicht korrekt ist, gib ihn zurück an den Eingang.',
    en: 'If this journal entry is not correct, return it to the input.',
    fr: "Si cette entrée de journal n'est pas correcte, renvoyez-la à l'entrée.",
  },
  wrongContentInfo: {
    de: 'Beschreibe was falsch ist / korrigiert werden muss.',
    en: 'Describe what is wrong / needs to be corrected.',
    fr: 'Décrivez ce qui ne va pas/doit être corrigé.',
  },
  toCorrect: {
    de: 'Zu korrigieren:',
    en: 'To correct:',
    fr: 'À corriger:',
  },
  backToInput: {
    de: 'Zurück an Eingang senden',
    en: 'Return to input',
    fr: "Renvoyer à l'entrée",
  },
  wrongDepartment: {
    de: 'Falscher Fachbereich',
    en: 'Wrong department',
    fr: 'Mauvais département',
  },
  triage: {
    de: 'Triage',
    en: 'Triage',
    fr: 'Triage',
  },
  wrongTriage: {
    de: 'Falls dieser Journaleintrag nicht in deinen Fachbereich gehört gib ihn zurück an die Triage.',
    en: 'If this journal entry does not belong to your department, return it to the triage.',
    fr: 'Si cette entrée de journal ne vous appartient pas, renvoyez-la au triage.',
  },
  wrongTriageInfo: {
    de: 'Warum gehört er nicht in deinen Fachbereich?',
    en: "Why doesn't it belong to your department?",
    fr: "Pourquoi n'est-il pas à toi?",
  },
  backToTriage: {
    de: 'Zurück zur Triage',
    en: 'Back to triage',
    fr: 'Retour au triage',
  },
  allDepartments: {
    de: 'Alle Fachbereiche',
    en: 'All departments',
    fr: 'Tous les départements',
  },
  deliveryTime: {
    de: 'Übermittlungszeit',
    en: 'Delivery time',
    fr: 'Heure de livraison',
  },
  deliveredFrom: {
    de: 'Übermittelt durch',
    en: 'Delivered from',
    fr: 'Livré par',
  },

  reset: {
    de: 'Zurücksetzen',
    en: 'Reset',
    fr: 'Réinitialiser',
  },

  searchAddress: {
    de: 'Adresse suchen',
    en: 'Search address',
    fr: 'Rechercher une adresse',
  },
  searchAddressTypeToSearch: {
    de: 'Tippen, um zu suchen',
    en: 'Type to search',
    fr: 'Saisir pour rechercher',
  },
  searchAddressEscToExit: {
    de: 'Esc zum Beenden',
    en: 'Esc to exit',
    fr: 'Échap pour quitter',
  },
  addAddress: {
    de: 'Adresse hinzufügen',
    en: 'Add address',
    fr: 'Ajouter une adresse',
  },
  searchAddressUsageHint: {
    de: `Um Adressinformationen einzufügen, geben Sie "${ADDRESS_TRIGGER_CHAR}" ein oder drücken Sie Ctrl+Leertaste.\nZum Bearbeiten doppelklicken Sie in den Bereich oder drücken Sie Ctrl+Leertaste.`,
    en: `To insert address information, type "${ADDRESS_TRIGGER_CHAR}" or press Ctrl+Space.\nTo edit, double-click in the area or press Ctrl+Space.`,
    fr: `Pour insérer une adresse, saisissez "${ADDRESS_TRIGGER_CHAR}" ou appuyez sur Ctrl+Espace.\nPour la modifier, double-cliquez dans la zone ou appuyez sur Ctrl+Espace.`,
  },
  markPotentialAddresses: {
    de: 'Adressen erkennen',
    en: 'Recognize addresses',
    fr: 'Repérer adresses',
  },
  unmarkPotentialAddresses: {
    de: 'Adressen bereinigen',
    en: 'Clean up addresses',
    fr: 'Nettoyer adresses',
  },
  errorSaving: {
    de: 'Fehler beim Speichern',
    en: 'Error saving',
    fr: "Erreur lors de l'enregistrement",
  },
  storedLocallyOnly: {
    de: 'Nur lokal gespeichert.',
    en: 'Stored locally only.',
    fr: 'Stocké localement uniquement.',
  },
  fillAllFields: {
    de: 'Bitte füllen Sie alle benötigten Felder aus.',
    en: 'Please fill in all required fields.',
    fr: 'Veuillez remplir tous les champs obligatoires.',
  },
  closeNotSaved: {
    de: 'Sie haben noch nicht gespeicherte Änderungen, möchten Sie diese verwerfen?',
    en: 'You have unsaved changes, do you want to discard them?',
    fr: 'Vous avez des modifications non enregistrées, souhaitez-vous les ignorer?',
  },
  discardEntryConfirm: {
    de: 'Möchtest du den Eintrag wirklich verwerfen?',
    en: 'Do you really want to discard the entry?',
    fr: "Voulez-vous vraiment rejeter l'entrée?",
  },
  continueEditingAction: {
    de: 'Bearbeiten fortsetzen',
    en: 'Continue editing',
    fr: 'Continuer à modifier',
  },
  discardEntry: {
    de: 'Eintrag verwerfen',
    en: 'Discard entry',
    fr: "Rejeter l'entrée",
  },
  entryCreated: {
    de: 'Eintrag #{number} erfasst.',
    en: 'Entry #{number} created.',
    fr: 'Entrée #{number} créée.',
  },

  //journal list
  showOnMap: {
    de: 'Auf Karte anzeigen',
    en: 'Show on map',
    fr: 'Afficher sur la carte',
  },
  journalNotHistory: {
    de: 'Anzeige aktuell, nicht auf Stand Sicherungszeitpunkt.',
    en: 'Display is current, not at the time of backup.',
    fr: "L'affichage est actuel, pas au moment de la sauvegarde.",
  },
  errorLoadingJournalEntries: {
    de: 'Fehler beim laden der Journal Einträge.',
    en: 'Error loading journal entries.',
    fr: 'Erreur lors du chargement des entrées de journal.',
  },
  showCachedJournalEntries: {
    de: 'Es werden nur lokal gecachte Journal Einträge angezeigt.',
    en: 'Only locally cached journal entries are displayed.',
    fr: 'Seules les entrées de journal mises en cache localement sont affichées.',
  },
  localOnlyJournal: {
    de: 'Dieser Journal Eintrag existiert nur Lokal.',
    en: 'This journal entry only exists locally.',
    fr: 'Cette entrée de journal existe uniquement localement.',
  },
  localPatchJournal: {
    de: 'Dieser Journal Eintrag hat Änderungen die nur lokal sind.',
    en: 'This journal entry has changes that are only local.',
    fr: 'Cette entrée de journal comporte des modifications qui sont uniquement locales.',
  },
  customizePrintForm: {
    de: 'Druckformular anpassen',
    en: 'Customize print form',
    fr: "Personnaliser le formulaire d'impression",
  },
  reloadFromServer: {
    de: 'Neu laden vom Server',
    en: 'Reload from server',
    fr: 'Recharger depuis le serveur',
  },
  journalEntryTemplate: {
    de: 'Meldungs Vorlage',
    en: 'Message template',
    fr: 'Modèle de message',
  },
  printEmptySavedTemplate: {
    de: 'Gespeicherte Vorlage drucken, leer',
    en: 'Print saved template, empty',
    fr: 'Imprimer le modèle enregistré, vide',
  },
  input: {
    de: 'Eingang',
    en: 'Input',
    fr: 'Entrée',
  },
  output: {
    de: 'Ausgang',
    en: 'Output',
    fr: 'Sortie',
  },
  searchText: {
    de: 'Suche',
    en: 'Search',
    fr: 'Recherche',
  },
  map: {
    de: 'Karte',
    en: 'Map',
    fr: 'Carte',
  },
  noInfo: {
    de: 'Keine Angabe',
    en: 'No information',
    fr: "Pas d'information",
  },
  responsibility: {
    de: 'Verantwortlichkeit',
    en: 'Responsibility',
    fr: 'Responsabilité',
  },
  status: {
    de: 'Status',
    en: 'Status',
    fr: 'Statut',
  },
  decision: {
    de: 'Entscheid',
    en: 'Decision',
    fr: 'Décision',
  },
  dateCreated: {
    de: 'Erstellungsdatum',
    en: 'Creation date',
    fr: 'Date de création',
  },
  messageNumberShort: {
    de: 'Nummer',
    en: 'Number',
    fr: 'Numéro',
  },
  messageNumberShort2: {
    de: 'Nr.',
    en: 'No.',
    fr: 'n°',
  },
  dateMessage: {
    de: 'Meldung Zeitpunkt',
    en: 'Report time',
    fr: 'Heure de rapport',
  },
  entryStatus: {
    de: 'Aktueller Status',
    en: 'Current state',
    fr: 'Statut actuel',
  },
  updatedAt: {
    de: 'Änderungsdatum',
    en: 'updated at',
    fr: 'mis à jour le',
  },
  create: {
    de: 'Erfassen',
    en: 'create',
    fr: 'créer',
  },
  createNewEntry: {
    de: 'Neuer Eintrag erfassen',
    en: 'Create new entry',
    fr: 'Créer une nouvelle entrée',
  },

  //journal sidebar
  showInJournal: {
    de: 'Im Journal anzeigen',
    en: 'Show in journal',
    fr: 'Afficher dans le journal',
  },
  noEntriesToDraw: {
    de: 'Keine Einträge zu zeichnen',
    en: 'No entries to draw',
    fr: 'Aucune entrée à dessiner',
  },
  noEntriesToDrawDescription: {
    de: 'Es gibt derzeit keine Journaleinträge, die noch gezeichnet werden müssen.',
    en: 'There are currently no journal entries that need to be drawn yet.',
    fr: "Il n'y a actuellement aucune entrée de journal à dessiner.",
  },
  noEntriesDrawn: {
    de: 'Keine abgeschlossenen Einträge',
    en: 'No completed entries',
    fr: 'Aucune entrée terminée',
  },
  noEntriesDrawnDescription: {
    de: 'Es gibt derzeit keine Journaleinträge, bei denen das Zeichnen abgeschlossen ist.',
    en: 'There are currently no journal entries where drawing has been completed.',
    fr: "Il n'y a actuellement aucune entrée de journal où le dessin a été terminé.",
  },
  someoneIsDrawing: {
    de: 'Jemand hat bereits mit Zeichnen begonnen.',
    en: 'Someone started drawing',
    fr: "Quelqu'un a commencé à dessiner",
  },
  markAsDrawn: {
    de: 'Als done markieren',
    en: 'Mark as done',
    fr: 'Marquer comme terminé',
  },
  drawnSymbols: {
    de: 'Gezeichnete Signaturen',
    en: 'Drawn symbols',
    fr: 'Symboles dessinés',
  },
  zoomToAll: {
    de: 'Auf alle gezeichnete Signaturen zoomen',
    en: 'Zoom to all drawn signatures',
    fr: 'Zoomez sur toutes les signatures dessinées',
  },
  noSignatureAvailable: {
    de: 'Keine Signatur vorhanden.',
    en: 'No signature available.',
    fr: 'Aucune signature disponible.',
  },
  addSignature: {
    de: 'Signatur hinzufügen',
    en: 'Add signature',
    fr: 'Ajouter une signature',
  },
  focusSignatures: {
    de: 'Signaturen fokussieren',
    en: 'Focus signatures',
    fr: 'Mettre en évidence les signatures',
  },
  signaturesNotComplete: {
    de: 'Signaturen nicht komplett',
    en: 'Signatures not complete',
    fr: 'Signatures incomplètes',
  },
  todo: {
    de: 'Todo',
    en: 'Todo',
    fr: 'À faire',
  },
  done: {
    de: 'Done',
    en: 'Done',
    fr: 'Terminé',
  },

};
